import React, { createContext, useContext, useMemo } from 'react';
import enUS from 'antd/locale/en_US';
import daDK from 'antd/locale/da_DK';

const translations = {
  da: {
    'Overview': 'Oversigt',
    'Sales Quotes / Orders': 'Salgstilbud / Ordrer',
    'Products': 'Produkter',
    'Counterparties': 'Modparter',
    'Customers': 'Kunder',
    'Inquiries': 'Forespørgsler',
    'Internal Quotes': 'Interne tilbudsforespørgsler',
    'Quotes': 'Tilbudsforespørgsler',
    'Sales Quotes': 'Salgstilbud',
    'Sales Quote': 'Salgstilbud',
    'Internal Quote': 'Intern tilbudsforespørgsel',
    'Orders': 'Ordrer',
    'Day': 'Dag',
    'Days': 'Dage',
    'Compliance': 'Overholdelse',
    'Coming soon': 'Kommer snart',
    'New Inquiry': 'Ny forespørgsel',
    'Add New Inquiry': 'Tilføj ny forespørgsel',
    'Edit Inquiry': 'Rediger forespørgsel',
    'Sent to Procurement': 'Sendt til indkøb',
    'Ready for Procurement': 'Klar til indkøb',
    'Quotation in Process': 'Tilbudsberegning i gang',
    'Ready for Sales Quote': 'Klar til salgstilbud',
    'Sent to Sales Quote': 'Sendt til salgstilbud',
    'New Sales Quote': 'Nyt salgstilbud',
    'Sent to the Customer': 'Sendt til kunden',
    'Customer Accepted': 'Kunde accepteret',
    'Order Created': 'Ordre oprettet',
    'Sales Quote Canceled': 'Salgstilbud annulleret',
    'New Order': 'Ny ordre',
    'Sent to the Implementation': 'Sendt til produktion',
    'Waiting for Delivery': 'Afventer levering',
    'Delivered': 'Leveret',
    'Accepted by Customer': 'Accepteret af kunde',
    'Order Canceled': 'Ordre annulleret',
    'Quote': 'Tilbudsforespørgsel',
    'Quote Created': 'Tilbudsforespørgsel oprettet',
    'Create Quote': 'Opret tilbudsforespørgsel',
    'View Quote': 'Vis tilbudsforespørgsel',
    'Quote created': 'Tilbudsforespørgsel oprettet',
    'From Inquiry': 'Fra forespørgsel',
    'Quote must be Sent to Sales Quote to create the offer': 'Tilbudsforespørgslen skal have status Sendt til salgstilbud for at kunne oprette tilbuddet',
    'Mark Ready for Sales Quote': 'Markér klar til salgstilbud',
    'Quote Products': 'Tilbudsforespørgselsprodukter',
    'Read-only — this quote has been converted to an offer': 'Skrivebeskyttet — denne tilbudsforespørgsel er konverteret til et tilbud',
    'Remove this item from the quote?': 'Fjern denne linje fra tilbudsforespørgslen?',
    'Branding': 'Branding',
    'Delivery': 'Levering',
    'Product Supplier': 'Produktleverandør',
    'Production Supplier': 'Produktionsleverandør',
    'Branding Supplier': 'Brandingleverandør',
    'Delivery Supplier': 'Leveringsleverandør',
    'Not assigned': 'Ikke tildelt',
    'Change': 'Skift',
    'Use This Supplier': 'Brug denne leverandør',
    'Already used in this Quote': 'Allerede brugt i denne tilbudsforespørgsel',
    'No eligible suppliers for this role': 'Ingen relevante leverandører til denne rolle',
    'Grand Total — Internal': 'Samlet total — internt',
    'Grand Total — Customer': 'Samlet total — kunde',
    'Create Offer': 'Opret tilbud',
    'Create Sales Quote': 'Opret salgstilbud',
    'Connect to Sales Quote': 'Forbind til salgstilbud',
    'Create Order': 'Opret ordre',
    'Yes': 'Ja',
    'No': 'Nej',
    'The Inquiry has been sent to Procurement. Would you like to create a Quote based on this Inquiry?': 'Forespørgslen er sendt til indkøb. Vil du oprette en tilbudsforespørgsel baseret på denne forespørgsel?',
    'The Quote has been sent to Offer. Would you like to create an Offer based on this Quote?': 'Tilbudsforespørgslen er sendt til tilbud. Vil du oprette et tilbud baseret på denne tilbudsforespørgsel?',
    'The Offer has reached the Order Created status. Would you like to create an Order based on this Internal Quote?': 'Tilbuddet har nået status Ordre oprettet. Vil du oprette en ordre baseret på denne interne tilbudsforespørgsel?',
    'Converted to order': 'Konverteret til ordre',
    'Source offer': 'Oprindeligt tilbud',
    'Seller': 'Sælger',
    'Deadline': 'Deadline',
    'Requested Delivery Date': 'Ønsket leveringsdato',
    'Product Category': 'Produktkategori',
    'Select category': 'Vælg kategori',
    'Select product': 'Vælg produkt',
    'Select category first': 'Vælg kategori først',
    'Supplier Products': 'Leverandørprodukter',
    'Add Supplier Product': 'Tilføj leverandørprodukt',
    'Edit Supplier Product': 'Rediger leverandørprodukt',
    'Delete Supplier Product': 'Slet leverandørprodukt',
    'Supplier Services': 'Leverandørydelser',
    'No services assigned yet': 'Ingen ydelser er tildelt endnu',
    'Delete Supplier Service': 'Slet leverandørydelse',
    'Supplier Logistics': 'Leverandørlogistik',
    'No logistics items assigned yet': 'Ingen logistikvarer er tildelt endnu',
    'Delete Supplier Logistics Item': 'Slet leverandørlogistikvare',
    'Supplier product created': 'Leverandørprodukt oprettet',
    'Supplier product updated': 'Leverandørprodukt opdateret',
    'Supplier Item Number': 'Leverandørens varenummer',
    'Supplier article / SKU': 'Leverandørens artikel / SKU',
    'Supplier-specific product name': 'Leverandørspecifikt produktnavn',
    'Item description / characteristics': 'Beskrivelse / egenskaber',
    'Sample Photo': 'Prøvefoto',
    'Upload Photo': 'Upload foto',
    'Not provided': 'Ikke angivet',
    'Average Item Price': 'Gns. varepris',
    'Used as this supplier’s price in supplier comparison.': 'Bruges som denne leverandørs pris i leverandørsammenligning.',
    'Average Production Price': 'Gns. produktionspris',
    'Average Branding Price': 'Gns. brandingpris',
    'Average Delivery Price per Item per Kilometer': 'Gns. leveringspris pr. enhed pr. km',
    'Avg. item price': 'Gns. varepris',
    'No suppliers assigned yet': 'Ingen leverandører tilknyttet endnu',
    'Please select a product category and product': 'Vælg venligst en produktkategori og et produkt',
    'Visibility': 'Synlighed',
    'Standard': 'Standard',
    'Branding-Only': 'Kun branding',
    'Delivery-Only': 'Kun levering',
    'Please select visibility': 'Vælg venligst synlighed',
    'Please select supplier type': 'Vælg venligst leverandørtype',
    'Requested Quantity': 'Ønsket antal',
    'Budget/Target Price (DKK)': 'Budget/målpris (DKK)',
    'Printing/Decoration Type': 'Print-/dekorationstype',
    'Print, embroidery...': 'Print, broderi...',
    'Urgent': 'Akut',
    'Re-order': 'Genbestilling',
    'Special Requirements': 'Særlige krav',
    'Notes': 'Noter',
    'Files can be described in the notes — file upload can be added in a later version.': 'Filer kan beskrives i noterne — filupload kan tilføjes i en senere version.',
    'Please select a seller': 'Vælg venligst en sælger',
    'Please select a customer': 'Vælg venligst en kunde',
    'Cancel': 'Annuller',
    'Bold': 'Fed',
    'Italic': 'Kursiv',
    'Underline': 'Understreget',
    'Bulleted list': 'Punktopstilling',
    'Contact Records': 'Kontaktregistreringer',
    'Files': 'Filer',
    'Personal Profile': 'Personlig profil',
    'User Management': 'Brugeradministration',
    'Logout': 'Log ud',
    'English': 'Engelsk',
    'Danish': 'Dansk',
    'SmartBoard CRM': 'SmartBoard CRM',
    'Welcome back! Please login to continue.': 'Velkommen tilbage! Log venligst ind for at fortsætte.',
    'Please input your username!': 'Indtast venligst dit brugernavn!',
    'Please input your password!': 'Indtast venligst din adgangskode!',
    'Username': 'Brugernavn',
    'Password': 'Adgangskode',
    'Login': 'Log ind',
    'Login successful!': 'Login gennemført!',
    'Invalid credentials': 'Ugyldige loginoplysninger',
    'Logged out successfully': 'Du er logget ud',
    'Personal profile updated': 'Personlig profil er opdateret',
    'Client updated': 'Klient er opdateret',
    'Lead created': 'Klient er oprettet',
    'Counterparty created': 'Modpart er oprettet',
    'User marked as Active': 'Bruger markeret som aktiv',
    'User marked as Inactive': 'Bruger markeret som inaktiv',
    'User updated': 'Bruger er opdateret',
    'User created': 'Bruger er oprettet',
    'Supplier updated': 'Leverandør er opdateret',
    'Supplier created': 'Leverandør er oprettet',
    'Product updated': 'Produkt er opdateret',
    'Product created': 'Produkt er oprettet',
    'Please select a product': 'Vælg venligst et produkt',
    'Please select a supplier': 'Vælg venligst en leverandør',
    'Item updated': 'Linje er opdateret',
    'Comment added successfully': 'Kommentar tilføjet',
    'Status updated to: {{status}}': 'Status opdateret til: {{status}}',
    'Please enter a comment': 'Skriv venligst en kommentar',
    'Comment added': 'Kommentar tilføjet',
    'File uploaded successfully': 'Fil uploadet',
    'Delete File': 'Slet fil',
    'Are you sure you want to delete this file?': 'Er du sikker på, at du vil slette denne fil?',
    'Delete': 'Slet',
    'File deleted successfully': 'Fil slettet',
    'Description updated': 'Beskrivelse opdateret',
    'Opening PDF preview for: {{fileName}}': 'Åbner PDF-forhåndsvisning for: {{fileName}}',
    'Create Counterparty': 'Opret modpart',
    'Client': 'Klient',
    'Supplier': 'Leverandør',
    'Private supplier': 'Privat leverandør',
    'Contact Record Details': 'Detaljer for kontaktregistrering',
    'Contact Date': 'Kontaktdato',
    'Client & Supplier Name': 'Klient- og leverandørnavn',
    'Type': 'Type',
    'Contact Source': 'Kontaktkilde',
    'Contact By': 'Kontaktet af',
    'Subject': 'Emne',
    'Description': 'Beskrivelse',
    'Edit': 'Rediger',
    'Repeat': 'Gentag',
    'Comments - {{name}}': 'Kommentarer - {{name}}',
    'Close': 'Luk',
    'Back': 'Tilbage',
    'Add Comment': 'Tilføj kommentar',
    'Comments': 'Kommentarer',
    'Follow-ups': 'Opfølgninger',
    'My Follow-ups': 'Mine opfølgninger',
    'My Team Follow-ups': 'Mit teams opfølgninger',
    'Read only': 'Kun læsning',
    'Follow-up date': 'Opfølgningsdato',
    'Priority': 'Prioritet',
    'High': 'Høj',
    'Medium': 'Mellem',
    'Low': 'Lav',
    'All priorities': 'Alle prioriteter',
    'Search by description or order ID': 'Søg på beskrivelse eller ordre-ID',
    'Add Follow-up': 'Tilføj opfølgning',
    'Date': 'Dato',
    'Responsible': 'Ansvarlig',
    'Ending in': 'Udløber om',
    'Status': 'Status',
    'Actions': 'Handlinger',
    'Add': 'Tilføj',
    'Done': 'Udført',
    'In Production': 'I produktion',
    'Pending': 'Afventer',
    'Not Done': 'Ikke udført',
    'No comments yet': 'Ingen kommentarer endnu',
    'Notifications': 'Notifikationer',
    'Mark all as read': 'Markér alle som læst',
    'No notifications': 'Ingen notifikationer',
    'The referenced document is no longer available': 'Det refererede dokument er ikke længere tilgængeligt',
    'Certificates': 'Certifikater',
    'Add Certificate': 'Tilføj certifikat',
    'Edit Certificate': 'Rediger certifikat',
    'Delete Certificate': 'Slet certifikat',
    'No certificates yet': 'Ingen certifikater endnu',
    'Certificate Name': 'Certifikatnavn',
    'Product-linked': 'Produktkoblet',
    'Generic': 'Generisk',
    'Generic (no product)': 'Generisk (intet produkt)',
    'Uploaded File': 'Uploadet fil',
    'Expiring Soon': 'Udløber snart',
    'Are you sure you want to delete "{{name}}"?': 'Er du sikker på, at du vil slette "{{name}}"?',
    'Certificate updated': 'Certifikat opdateret',
    'Certificate added': 'Certifikat tilføjet',
    'Certificate deleted': 'Certifikat slettet',
    'Certificate verified': 'Certifikat verificeret',
    'Scope': 'Omfang',
    'Please select scope': 'Vælg venligst omfang',
    'Please select product': 'Vælg venligst produkt',
    'Not applicable — supplier-wide': 'Ikke relevant — gælder hele leverandøren',
    'Verify Document': 'Verificér dokument',
    'Product Compliance': 'Produktoverholdelse',
    'Inherited from Supplier': 'Nedarvet fra leverandør',
    '{{valid}} valid · {{expiring}} expiring · {{unverified}} unverified': '{{valid}} gyldige · {{expiring}} udløber snart · {{unverified}} ikke verificeret',
    'All Scopes': 'Alle omfang',
    'All Documents': 'Alle dokumenter',
    'Needs verification': 'Kræver verifikation',
    'Document / Certificate': 'Dokument / certifikat',
    'Type / Standard': 'Type / standard',
    'Document Type': 'Dokumenttype',
    'Valid From': 'Gyldig fra',
    'Valid To': 'Gyldig til',
    'Expires In': 'Udløber om',
    'Uploaded By': 'Uploadet af',
    'Preview': 'Forhåndsvisning',
    'Expired': 'Udløbet',
    'Valid': 'Gyldigt',
    '{{count}} days': '{{count}} dage',
    'Name is required': 'Navn er påkrævet',
    'Name must be at most 255 characters': 'Navn må højst være 255 tegn',
    'Document type is required': 'Dokumenttype er påkrævet',
    'Standard is required': 'Standard er påkrævet',
    'Valid from date is required': 'Gyldig fra-dato er påkrævet',
    'Valid to date is required': 'Gyldig til-dato er påkrævet',
    'Supplier Quote': 'Leverandørtilbud',
    'Product Subtotal': 'Varedelsum',
    'Quote Total': 'Tilbudstotal',
    'Attachments': 'Vedhæftninger',
    'Expiry date is required': 'Udløbsdato er påkrævet',
    'Expiry date must not be in the past': 'Udløbsdato må ikke være i fortiden',
    'File Upload': 'Filupload',
    'Select File': 'Vælg fil',
    'Current file': 'Nuværende fil',
    'A file is required': 'En fil er påkrævet',
    'File must be one of .pdf, .png, .jpg, .jpeg, .doc, .docx and at most 10 MB': 'Filen skal være .pdf, .png, .jpg, .jpeg, .doc eller .docx og højst 10 MB',
    '{{count}} certificate(s) expiring soon or expired': '{{count}} certifikat(er) udløber snart eller er udløbet',
    'Search by supplier or certificate name': 'Søg efter leverandør- eller certifikatnavn',
    'Expiring Soon only': 'Kun udløber snart',
    'No certificates match': 'Ingen certifikater matcher',
    'No certificates': 'Ingen certifikater',
    'cert': 'certifikat',
    'certs': 'certifikater',
    'Product Cert': 'Produktcertifikat',
    'Selected product could not be found': 'Det valgte produkt kunne ikke findes',
    'Download': 'Download',
    'Archived': 'Arkiveret',
    'Inquiry ID': 'Forespørgsels-ID',
    'Quote ID': 'Tilbudsforespørgsels-ID',
    'Country': 'Land',
    'Currency': 'Valuta',
    'Default Currency': 'Standardvaluta',
    'Please select currency': 'Vælg venligst valuta',
    'Sales Rep': 'Sælger',
    'Created Date': 'Oprettelsesdato',
    'Next Step': 'Næste skridt',
    'Due Date': 'Forfaldsdato',
    'Archive': 'Arkivér',
    'Restore': 'Gendan',
    'All Statuses': 'Alle statusser',
    'All Customers': 'Alle kunder',
    'All Dates': 'Alle datoer',
    'Last 7 days': 'Sidste 7 dage',
    'Last 30 days': 'Sidste 30 dage',
    'Last 90 days': 'Sidste 90 dage',
    'Search by inquiry ID, customer or product...': 'Søg på forespørgsels-ID, kunde eller produkt...',
    'Search by quote ID, customer or product...': 'Søg på tilbudsforespørgsels-ID, kunde eller produkt...',
    'No inquiries match': 'Ingen forespørgsler matcher',
    'No archived inquiries': 'Ingen arkiverede forespørgsler',
    'No quotes match': 'Ingen tilbudsforespørgsler matcher',
    'e.g. Review details, Awaiting response...': 'f.eks. Gennemgå detaljer, Afventer svar...',
    'Denmark': 'Danmark',
    'Sweden': 'Sverige',
    'Norway': 'Norge',
    'Germany': 'Tyskland',
    'Finland': 'Finland',
    'China': 'Kina',
    'India': 'Indien',
    'Date, description, and responsible are required': 'Dato, beskrivelse og ansvarlig er påkrævet',
    'Follow-up updated': 'Opfølgning opdateret',
    'Follow-up added': 'Opfølgning tilføjet',
    'Follow-up deleted': 'Opfølgning slettet',
    'Total: {{count}} follow-ups': 'I alt: {{count}} opfølgninger',
    'Line Items — Split by Supplier': 'Linjer — opdelt efter leverandør',
    'No supplier line items for this offer/order': 'Ingen leverandørlinjer for dette tilbud / denne ordre',
    'Supplier #{{number}}': 'Leverandør #{{number}}',
    'Proof Pending': 'Afventer korrektur',
    'Production': 'Produktion',
    'Completed': 'Fuldført',
    'Subtotal — {{name}}': 'Subtotal — {{name}}',
    'Grand Total — Order value to client': 'Samlet total — ordreværdi til klient',
    'Order': 'Ordre',
    'Offer': 'Tilbud',
    'Pending (Draft)': 'Afventer (kladde)',
    'Pending (Sent)': 'Afventer (sendt)',
    'Pending (New)': 'Afventer (ny)',
    'Accepted': 'Accepteret',
    'Accepted with Changes': 'Accepteret med ændringer',
    'Rejected': 'Afvist',
    'In Progress': 'I gang',
    'Ready for procurement': 'Klar til indkøb',
    'Order confirmation sent': 'Ordrebekræftelse sendt',
    'Order confirmed': 'Ordre bekræftet',
    'Changes requested': 'Ændringer ønsket',
    'In layout preparation': 'I layoutforberedelse',
    'Layout in progress': 'Layout i gang',
    'Waiting for layout approval': 'Afventer layoutgodkendelse',
    'Layout revision': 'Layoutrevision',
    'Layout approved': 'Layout godkendt',
    'In production': 'I produktion',
    'Shipped from suppliers': 'Afsendt fra leverandører',
    'Delivered to customer': 'Leveret til kunde',
    'Customer': 'Kunde',
    'Prospect': 'Prospekt',
    'Lead/Prospect': 'Lead/Prospekt',
    'Phone': 'Telefon',
    'Email': 'E-mail',
    'Network': 'Netværk',
    'Fair/Event': 'Messe/event',
    'Referral': 'Henvisning',
    'All sources': 'Alle kilder',
    'Please select contact source': 'Vælg kontaktkilde',
    'Select contact source': 'Vælg kontaktkilde',
    'Referred by': 'Henvist af',
    'Please select who referred this contact': 'Vælg hvem der henviste kontakten',
    'Select existing client': 'Vælg eksisterende klient',
    'Event name': 'Eventnavn',
    'Event or fair name': 'Event- eller messenavn',
    'Please enter event name': 'Indtast eventnavn',
    'Event date': 'Eventdato',
    'Please select event date': 'Vælg eventdato',
    'Network name': 'Netværksnavn',
    'Please enter network name': 'Indtast netværksnavn',
    'Demo file download: {{fileName}}': 'Demo-fil download: {{fileName}}',
    'Other': 'Andet',
    'Open': 'Åben',
    'Overdue!': 'Forfalden!',
    'At the time': 'På tidspunktet',
    '1 day before': '1 dag før',
    '3 days before': '3 dage før',
    'In 7 days': 'Om 7 dage',
    'Contact Record': 'Kontaktregistrering',
    'Quote / Order': 'Tilbud / ordre',
    'Create': 'Opret',
    'Create Offer/Order': 'Opret tilbud / ordre',
    'Client Name': 'Klientnavn',
    'Contact Channels': 'Kontaktoplysninger',
    'Client Type': 'Klienttype',
    'Last Contact Date': 'Seneste kontaktdato',
    'Last Contact By': 'Senest kontaktet af',
    'Latest Offer/Order': 'Seneste tilbud / ordre',
    'Offer/Order Follow-ups': 'Tilbuds-/ordreopfølgninger',
    'Offer/Order Status': 'Tilbuds-/ordrestatus',
    'View details': 'Se detaljer',
    'Amount': 'Beløb',
    'Clear': 'Nulstil',
    'All statuses': 'Alle statusser',
    'Filter by status': 'Filtrer efter status',
    'ID': 'ID',
    'Suppliers': 'Leverandører',
    'Search by name, phone, email, or CVR': 'Søg på navn, telefon, e-mail eller CVR',
    'Counterparty Type': 'Modpartstype',
    'Contact Person': 'Kontaktperson',
    'Contact Persons': 'Kontaktpersoner',
    'Add Contact Person': 'Tilføj kontaktperson',
    'Edit Contact Person': 'Rediger kontaktperson',
    'Contact person created': 'Kontaktperson oprettet',
    'Contact person updated': 'Kontaktperson opdateret',
    'Name': 'Navn',
    'Position': 'Stilling',
    'Please enter name': 'Indtast navn',
    'Created': 'Oprettet',
    'Delete Counterparty': 'Slet modpart',
    'Are you sure you want to delete this entry?': 'Er du sikker på, at du vil slette denne post?',
    'Deleted': 'Slettet',
    'All types': 'Alle typer',
    'Clients & Suppliers': 'Klienter og leverandører',
    'Search contact records...': 'Søg i kontaktregistreringer...',
    'My Contact Records': 'Mine kontaktregistreringer',
    'All Contact Records': 'Alle kontaktregistreringer',
    'Delete Contact Record': 'Slet kontaktregistrering',
    'Edit Contact Record': 'Rediger kontaktregistrering',
    'Contact record created': 'Kontaktregistrering oprettet',
    'Contact record updated': 'Kontaktregistrering opdateret',
    'Contact record deleted': 'Kontaktregistrering slettet',
    'Select Counterparty Name': 'Vælg modpartsnavn',
    'Search by name': 'Søg efter navn',
    'Contact date from': 'Kontaktdato fra',
    'Contact date to': 'Kontaktdato til',
    'Add Contact Record': 'Tilføj kontaktregistrering',
    'Search by Product Name': 'Søg på produktnavn',
    'Active': 'Aktiv',
    'Inactive': 'Inaktiv',
    'Product marked active': 'Produkt markeret som aktivt',
    'Product marked inactive': 'Produkt markeret som inaktivt',
    'Product Name': 'Produktnavn',
    'Product': 'Produkt',
    'Stock': 'Lager',
    'Supplier Name': 'Leverandørnavn',
    'Price (DKK)': 'Pris (DKK)',
    'Price (from)': 'Pris (fra)',
    'Product Information': 'Produktoplysninger',
    'Alternative Suppliers': 'Alternative leverandører',
    'Alternative Supplier': 'Alternativ leverandør',
    'Back to Products': 'Tilbage til produkter',
    'Article': 'Artikel',
    'Supplier article': 'Leverandørartikel',
    'Internal Price': 'Intern pris',
    'Customer Price': 'Kundepris',
    'Add Product': 'Tilføj produkt',
    'Standard Product': 'Standardprodukt',
    'Custom Product': 'Specialprodukt',
    'Product Type': 'Produkttype',
    'Product Number': 'Produktnummer',
    'Internal Number': 'Internt nummer',
    'Product Family': 'Produktfamilie',
    'Colour': 'Farve',
    'Copied From': 'Kopieret fra',
    'Material': 'Materiale',
    'Country of Origin': 'Oprindelsesland',
    'Packaging': 'Emballage',
    'Unit Packaging': 'Enhedsemballage',
    'Items per Carton': 'Enheder pr. karton',
    'Carton Dimensions (cm)': 'Kartonmål (cm)',
    'Carton Gross Weight (kg)': 'Bruttovægt pr. karton (kg)',
    'Specification': 'Specifikation',
    'Specifications': 'Specifikationer',
    'Materials': 'Materialer',
    'Production Notes': 'Produktionsnoter',
    'Add Note': 'Tilføj note',
    'No production notes yet': 'Ingen produktionsnoter endnu',
    'Add a new production note...': 'Tilføj en ny produktionsnote...',
    'Please enter a note': 'Skriv venligst en note',
    'Note added': 'Note tilføjet',
    'Created By': 'Oprettet af',
    'Documents': 'Dokumenter',
    'History': 'Historik',
    'Owning Supplier': 'Ejerleverandør',
    'Please select supplier': 'Vælg venligst leverandør',
    'Select supplier': 'Vælg leverandør',
    'Leave blank to auto-generate an internal number instead.': 'Lad stå tomt for automatisk at generere et internt nummer.',
    'Product type cannot be changed after creation.': 'Produkttype kan ikke ændres efter oprettelse.',
    'Standard Product Information': 'Standardproduktoplysninger',
    'Custom Product Information': 'Specialproduktoplysninger',
    'Thumbnail': 'Miniature',
    'Group by Family': 'Gruppér efter familie',
    'Copy Product': 'Kopiér produkt',
    'Copy this Product': 'Kopiér dette produkt',
    'New Standard Product': 'Nyt standardprodukt',
    'New Custom Product': 'Nyt specialprodukt',
    'One supplier, one supplier item number, one colour.': 'Én leverandør, ét leverandørvarenummer, én farve.',
    'A one-off production made for a specific customer.': 'En engangsproduktion lavet til en specifik kunde.',
    'Copy Existing Product': 'Kopiér eksisterende produkt',
    'Start from an existing product — for a colour variation or a repeat custom job.': 'Start ud fra et eksisterende produkt — til en farvevariant eller en gentaget specialopgave.',
    'Select Product to Copy': 'Vælg produkt der skal kopieres',
    'Review Copy': 'Gennemgå kopi',
    'Create Copy': 'Opret kopi',
    'Copying from {{name}}': 'Kopierer fra {{name}}',
    'What you need to change': 'Hvad du skal ændre',
    'What will be copied': 'Hvad kopieres',
    'Copied automatically': 'Kopieres automatisk',
    'Cleared — please complete': 'Ryddet — udfyld venligst',
    'What will not be copied': 'Hvad kopieres ikke',
    'Inherited — verification required': 'Nedarvet — kræver verifikation',
    'Prices are not copied between customers.': 'Priser kopieres ikke mellem kunder.',
    '{{count}} products were copied from this one': '{{count}} produkter er kopieret fra dette',
    'Copy created as {{number}}': 'Kopi oprettet som {{number}}',
    'Please select document type': 'Vælg venligst dokumenttype',
    'Set as Main Image': 'Vælg som hovedbillede',
    'Add Document': 'Tilføj dokument',
    'Images': 'Billeder',
    'Add Image': 'Tilføj billede',
    'No images yet': 'Ingen billeder endnu',
    'Image Name': 'Billednavn',
    'Upload Date': 'Uploaddato',
    'Edit Document': 'Rediger dokument',
    'Document uploaded': 'Dokument uploadet',
    'Document updated': 'Dokument opdateret',
    'Image': 'Billede',
    'Datasheet': 'Datablad',
    'BrandingTemplate': 'Brandingskabelon',
    'Artwork': 'Grafik',
    'PackagingSpec': 'Emballagespecifikation',
    'ProductionNote': 'Produktionsnote',
    'TestReport': 'Testrapport',
    'Line Type': 'Linjetype',
    'Service': 'Ydelse',
    'Logistics': 'Logistik',
    'Add Line Item': 'Tilføj linje',
    'Edit Line Item': 'Rediger linje',
    'Select a service': 'Vælg en ydelse',
    'Select a logistics item': 'Vælg en logistikydelse',
    'Logistics Item': 'Logistikydelse',
    'Fixed fee — quantity is not applicable': 'Fast gebyr — antal er ikke relevant',
    'Services': 'Ydelser',
    'Add Service': 'Tilføj ydelse',
    'Edit Service': 'Rediger ydelse',
    'Search by code or service name': 'Søg på kode eller ydelsesnavn',
    'Service Name': 'Ydelsesnavn',
    'Service Type': 'Ydelsestype',
    'Service updated': 'Ydelse opdateret',
    'Service created': 'Ydelse oprettet',
    'Add Logistics Item': 'Tilføj logistikydelse',
    'Edit Logistics Item': 'Rediger logistikydelse',
    'Search by code or logistics item name': 'Søg på kode eller navn på logistikydelse',
    'Logistics Item Name': 'Navn på logistikydelse',
    'Logistics item updated': 'Logistikydelse opdateret',
    'Logistics item created': 'Logistikydelse oprettet',
    'Code': 'Kode',
    'Code is required': 'Kode er påkrævet',
    'Please enter service name': 'Angiv venligst ydelsesnavn',
    'Please enter logistics item name': 'Angiv venligst navn på logistikydelse',
    'Pricing Unit': 'Prisenhed',
    'Decoration scales with order quantity; Charge is a one-off flat fee.': 'Dekoration skalerer med ordreantal; Gebyr er et engangsbeløb.',
    'Decoration': 'Dekoration',
    'Charge': 'Gebyr',
    'PerUnit': 'Pr. enhed',
    'FixedFee': 'Fast gebyr',
    'PerKg': 'Pr. kg',
    'PerCbm': 'Pr. m³',
    'Digital Print': 'Digitaltryk',
    'Screen Print': 'Silketryk',
    'Pad Printing': 'Tampontryk',
    'Laser Engraving': 'Lasergravering',
    'Embroidery': 'Broderi',
    'Heat Transfer': 'Transfertryk',
    'Sublimation': 'Sublimering',
    'Setup Charge': 'Opsætningsgebyr',
    'Sample Charge': 'Prøvegebyr',
    'Tooling / Mold Charge': 'Værktøjs-/mold-gebyr',
    'Handling': 'Håndtering',
    'Sea Freight': 'Søfragt',
    'Air Freight': 'Luftfragt',
    'Courier': 'Kurer',
    'Applies to product line': 'Gælder for produktlinje',
    'Optional — link to a product line': 'Valgfrit — knyt til en produktlinje',
    'Service is required': 'Ydelse er påkrævet',
    'Logistics item is required': 'Logistikydelse er påkrævet',
    'e.g. SRV-SCR': 'f.eks. SRV-SCR',
    'e.g. LOG-SEA': 'f.eks. LOG-SEA',
    'Service name': 'Ydelsesnavn',
    'Logistics item name': 'Navn på logistikydelse',
    'Back to List': 'Tilbage til liste',
    'No products assigned yet': 'Ingen produkter er tildelt endnu',
    'Quick overview and actions': 'Hurtigt overblik og handlinger',
    'Manage prospects and customers': 'Administrer prospekter og kunder',
    'Track communication history': 'Følg kommunikationshistorik',
    'View and manage all deals': 'Se og administrer alle aftaler',
    'Add New Product': 'Tilføj nyt produkt',
    'Edit Product': 'Rediger produkt',
    'Please enter product name': 'Indtast produktnavn',
    'Product name': 'Produktnavn',
    'Product description': 'Produktbeskrivelse',
    'Select active supplier': 'Vælg aktiv leverandør',
    'Please enter price': 'Indtast pris',
    'Price': 'Pris',
    'Add New Supplier': 'Tilføj ny leverandør',
    'Edit Supplier': 'Rediger leverandør',
    'Please enter supplier name': 'Indtast leverandørnavn',
    'Supplier name': 'Leverandørnavn',
    'CVR Number': 'CVR-nummer',
    'CVR number': 'CVR-nummer',
    'Address': 'Adresse',
    'Full address': 'Fuld adresse',
    'Contact Phone': 'Kontakttelefon',
    'Contact Email': 'Kontakt-e-mail',
    'Website': 'Websted',
    'Please enter a valid website URL': 'Indtast en gyldig webadresse',
    'Add New Lead/Client': 'Tilføj ny lead/klient',
    'Edit Client': 'Rediger klient',
    'Client name': 'Klientnavn',
    'Contact person name': 'Kontaktpersonens navn',
    'Update your personal details and preferred working language.': 'Opdater dine personlige oplysninger og foretrukne arbejdssprog.',
    'First Name': 'Fornavn',
    'Last Name': 'Efternavn',
    'Preferred Language': 'Foretrukket sprog',
    'Save Changes': 'Gem ændringer',
    'Please enter first name': 'Indtast fornavn',
    'Please enter last name': 'Indtast efternavn',
    'Please enter phone number': 'Indtast telefonnummer',
    'Please enter email address': 'Indtast e-mailadresse',
    'Please enter a valid email address': 'Indtast en gyldig e-mailadresse',
    'Please select preferred language': 'Vælg foretrukket sprog',
    'Update': 'Opdater',
    'Save': 'Gem',
    'Select type': 'Vælg type',
    'Other (Meeting, etc.)': 'Andet (møde osv.)',
    'Brief description': 'Kort beskrivelse',
    'Detailed notes...': 'Detaljerede noter...',
    'Add a new comment...': 'Tilføj en ny kommentar...',
    'Select date': 'Vælg dato',
  },
};

const antLocales = {
  en: enUS,
  da: daDK,
};

function interpolate(template, values) {
  return template.replace(/{{(.*?)}}/g, (_, key) => values[key.trim()] ?? '');
}

export function createTranslator(language) {
  return (key, values = {}) => {
    const template = language === 'da'
      ? translations.da[key] || key
      : key;
    return interpolate(template, values);
  };
}

export function getAntdLocale(language) {
  return antLocales[language] || enUS;
}

const I18nContext = createContext({
  language: 'en',
  setLanguage: () => {},
  t: (key, values) => createTranslator('en')(key, values),
});

export function I18nProvider({ language, setLanguage, children }) {
  const value = useMemo(() => ({
    language,
    setLanguage,
    t: createTranslator(language),
  }), [language, setLanguage]);

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
